import _ from 'lodash';

/**
 * @memberof module:util
 * @function
 * @name sortArrObjStr
 * @description It does sort array of object/strings i.e. city or country in Alphabetical Order for dropdowns port object.
 * Default sort is in ascending order.
 *
 * @param {Object | Array} ArrOrObjOrStr - it's the Object or array of strings/objects
 * @param {string} [arrKey=undefined] - It is "Ports" for example like portsJson.Ports array
 * @param {string} [objKey=undefined] - It is "Name" for example single port.Name or single port.city
 * @returns {Array} new sorted array
 *
 * @example
 * console.log(sortArrObjStr(["Mumbai","Delhi"]))
 *
 * // output
 * ["Delhi", "Mumbai"]
 *
 * console.log(sortArrObjStr({"Ports": [{"Name": "Mumbai"},{"Name": "Delhi"},...]}, "Ports", "Name"))
 *
 * // output
 * [{"Name": "Delhi"},{"Name": "Mumbai"}, ...]
 *
 * console.log(sortArrObjStr([{"Name": "Mumbai"},{"Name": "Delhi"},...], undefined, "Name"))
 *
 * // output
 * [{"Name": "Delhi"},{"Name": "Mumbai"}, ...]
 *
 */

export const sortArrObjStr = (
  ArrOrObjOrStr,
  arrKey = undefined,
  objKey = undefined
) => {
  let tempSortable = [];


  if (arrKey) {
    //if  ArrOrObjOrStr is obj and arrKey holds array of object in ArrOrObjOrStr
    tempSortable = ArrOrObjOrStr[arrKey];
  } else {
    // ArrOrObjOrStr is array of obj/strings itself
    tempSortable = ArrOrObjOrStr;
  }

  tempSortable = Array.isArray(tempSortable) ? tempSortable : [];

  if (objKey) {
    // sort array of obj
    return _.sortBy(tempSortable, (o) => o[objKey]);
  } else {
    // sort array of strings
    return _.sortBy(tempSortable);
  }
};
